import React from "react";
import Fade from "react-reveal/Fade";
import "./Project.css";
import { MdOutlineSlowMotionVideo } from "react-icons/md";
import { AiFillEye } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";

const Project = (props) => {
  return (
    <div
      style={{
        padding: "10px",
        background: "white",
        display: "flex",
        flexDirection: "column",
        height: "600px",
        gap: "5px",
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      <div>
        <img
          src={props.img}
          style={{
            objectFit: "cover",
            width: "100%",
            height: "200px",
            borderRadius: "10px",
          }}
          alt={props.title}
        />
      </div>
      <div>
        <h5
          class="card-title"
          style={{
            padding: "10px 0",
            color: "black",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Fade bottom cascade>
            {props.title}
          </Fade>
        </h5>
      </div>

      <ul class="list-group" style={{ border: "none" }}>
        <li
          class="list-group-item"
          style={{ height: "90px", overflow: "hidden", border: "none" }}
        >
          <b style={{ color: "black" }}>Description : </b>

          {props.desc}
        </li>
        <li
          class="list-group-item"
          style={{ height: "90px", overflow: "hidden", border: "none" }}
        >
          <b style={{ color: "black" }}>Features : </b>
          {props.feature}
        </li>
        <li
          class="list-group-item"
          style={{ height: "50px", overflow: "hidden", border: "none" }}
        >
          <b style={{ color: "black" }}>Tech Stacks : </b>
          {props.stacks}
        </li>
      </ul>
      <div
        style={{
          marginTop: "10px",
          height: "70px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        <button>
          <span>
            <a id="b" target="_blank" href={props.vid}>
              <MdOutlineSlowMotionVideo
                style={{
                  height: "32px",
                  width: "32px",
                }}
              />
            </a>
          </span>
        </button>
        <button>
          <span>
            {" "}
            <a id="b" target="_blank" href={props.link}>
              <AiFillEye
                style={{
                  height: "32px",
                  width: "32px",
                }}
              />
            </a>
          </span>
        </button>
        <button>
          <span>
            {" "}
            <a id="a" target="_blank" href={props.github}>
              <BsGithub
                style={{
                  height: "32px",
                  width: "32px",
                }}
              />
            </a>
          </span>
        </button>
      </div>
    </div>
  );
};

export default Project;
